import { InlineWidget } from 'react-calendly';
import { useUserContext } from '@src/contexts/useUserContext.ts';
export default function Contact({
  campaign,
  organisation,
}: Readonly<{
  campaign?: string;
  organisation: string;
}>) {
  const { user } = useUserContext();
  return (
    <InlineWidget
      url="https://calendly.com/funnellab_de/experten-meeting"
      prefill={{
        name: `${user.first_name} ${user.last_name}`,
        email: user.email ?? undefined,
      }}
      styles={{ flexGrow: '1', height: '100%' }}
      utm={{
        utmMedium: organisation,
        utmCampaign: campaign ?? undefined,
      }}
    />
  );
}
